<template>
 <div class="vsoccer-game div-container" v-visibility-change="changeBrowserTab">
  <div class="a-vs-wrapper">
      <div class="a-vs-wrapper--inner-main-wrapper">
        <div class="a-vs-b-header-wrap">
          <left-menu-container
            v-if="showMenuHeader && componentsVisible"
            :showLeftMenu = "showLeftMenu"
            :amount = "amount"
            :showBettingHistory = "showBettingHistory"
            :currency = "currency" />

          <betting-history v-show="showBettingHistory" :visible="showBettingHistory"/>

          <header-container
            v-show="!showBettingHistory"
            @onError="onError($event)"
            :videoList="videoList"
            :seek="videoSeek"
            :roundLength="roundLength"
            :totalVideoLength="totalVideoLength"
            :isDemoMode="isDemoMode"
            :metaDataVideoList="metaDataVideoList"
            :showFallenJackpots="showFallenJackpots"
            :showMatchResult="showMatchResult"
            :currency="currency"
            :videoResult="videoResult"
            :isEventExists="isEventExists"
            :headerResultShow="headerResultShow"
            :fallenJackpots="fallenJackpots"
            :currentGame="currentGame"
            :headerResult="headerResult"
            :headerResultHomeScore="headerResult.HomeScore"
            :headerResultAwayScore="headerResult.AwayScore" />

            <div v-show="!showBettingHistory" class="a-vs-header--overlay-bottom">
              <count-down-timer
                eventForTick="vsoccer_timer_tick"
                :isDisplayed ="!headerResultShow && !isPlayerEnabled"
                v-show="!headerResultShow"
                :roundNo="nextRoundNumber"
                :secondsToStart="secondsToStart"
                :roundLength="roundLength"
                :currentVGame="'VSoccer'"  />
              <result-line
                v-if="showResult()"
                :currentGame="currentGame"
                :headerResult="headerResult"
                :headerResultHomeScore="headerResult.HomeScore"
                :headerResultAwayScore="headerResult.AwayScore" />
            </div>
            <div v-show="!showBettingHistory" class="a-vs-b-next-matches">
              <div v-for="(event, index) in panelEvents"
                  :key="event.Event"
                  class="a-vs-c-single-match"  @click="clickTab(event)"
                  :class="{'active-tab': activeEvent === event}">
                <matches-slide
                  :event="event"
                  :numberOfSlide="index"
                  :roundLength ="roundLength"
                  :activeEvent="activeEvent"
                  :isMobileDesign="isMobile"/>
              </div>
            </div>
        </div>
        <main v-show="!showBettingHistory">
          <div class="one-match-container">
            <one-match v-if="isEventExists" :eventData="activeEvent" :isMobileDesign="isMobile"></one-match>
          </div>
        </main>
      </div>

      <aside :class="{'aside-pulled': showSideMenuMobile && isMobile}" v-if="!isMobile">
        <bet-placing
          class="a-vs-aside--bet-placing"
          id="VsoccerAside"
          v-if="config"
          :isBettingEnabled="isBettingEnabled"
          :config="config"
          :amount = "amount"/>

        <played-tickets/>
      </aside>

      <footer v-if="isEventExists"
              v-show="!showBettingHistory || (showBettingHistory && !isMobile)">
            <h2>{{$t('statistics')}}</h2>
            <div class="a-vs-b--statistics-wrap">

              <statistics-total-goals
                :eventData="activeEvent"
                :componentTitle="$t('total_goals')"
                :componentSubtitle="$t('last_5_matches_per_team')" />

              <statistics-form
                :eventData="activeEvent"
                :componentTitle="$t('form')"
                :componentSubtitle="$t('last_5_matches_per_team')"/>

              <statistics-headtohead
                :eventData="activeEvent"
                :componentTitle="$t('head_to_head')"
                :componentSubtitle="$t('last_5_matches')"/>
            </div>
      </footer>

      <floating-tab
        v-if="isMobile && componentsVisible"
        :showBettingHistory="showBettingHistory"
        :isBettingEnabled="isBettingEnabled"
        :config="config"
        :amount="amount"/>
        <modal-confirm v-if="isConfirmModalOpen" :eventData="activeEvent">
          <p slot="teams" class="teams">
            {{extractHomeTeamName(this.activeEvent)}} : {{extractAwayTeamName(this.activeEvent)}}
          </p>
          <p class="bet-type" slot="bet-type">
            {{$t(this.activeEvent.activeStake.TableName)}}: {{$t(this.activeEvent.activeStake.TableSubname)}} {{this.activeEvent.activeStake.Title}}
          </p>
        </modal-confirm>
    </div>

    <modal-connection-error v-if="showConnectionErrorModal" @close="showConnectionErrorModal = false"> </modal-connection-error>

    <modal-device-orientation v-if="showModal" @close="showModal = false"> </modal-device-orientation>

  </div>
</template>

<script>

import api from '@/services/soccer/api.service.network.js'
import { eventBus } from '@/main.js'
import Vue from 'vue'
import visibility from 'vue-visibility-change'
import EventConstants from '@/constants/Events'
import MobileDevice from '@/mixins/MobileDevice'
import HandleResize from '@/mixins/HandleResize.js'
import VSoccerHelper from '@/mixins/VSoccerHelper.js'
import ModalOnLandscape from '@/mixins/ModalOnLandscape.js'
import Elements from '@/mixins/Elements.js'
import HeaderContainer from '@/components/soccer/header/HeaderContainer.vue'
import VSoccerData from './VSoccerData.js'
import BettingHistoryShow from '@/mixins/BettingHistoryShow.js'
import { store } from '@/store/store.js'
import vuexStore from '../../store/vuexStore.js'

import selectMatch from '../../assets/audio/vSoccer/select_bet.mp3'

Vue.use(visibility)

export default {
  data: function () {
    return VSoccerData.data()
  },
  mixins: [MobileDevice, HandleResize, ModalOnLandscape, Elements,
    BettingHistoryShow, VSoccerHelper
  ],
  components: {
    'header-container': HeaderContainer
  },
  methods: {
    showResult: function () {
      return this.headerResultShow && this.isPlayerEnabled && this.isCurrentGameExists
    },
    onError (event) {
      this.getMatches()
    },
    changeBrowserTab (event, hidden) {
      if (!hidden) {
        this.getMatches(true)
      }
    },
    clickTab (event) {
      if (vuexStore.state.hasAudioEnabled) {
        var audio = new Audio(selectMatch)
        audio.play()
      }
      this.activeEvent = event
      this.checkIsModalOpen(event)
    },
    checkIsModalOpen (event) {
      this.openConfirmModal = (!event.isBetPlaced && event.activeStake)
    },
    openAsideMenuMobile () {
      this.showSideMenuMobile = true
    },
    onEventRemovePickedMatch (eventData) {
      if (this.activeEvent.EventID === eventData.EventID) {
        this.activeEvent.isBetPlaced = false
        this.activeEvent.activeStake = null
      }
      let removedEvent = this.panelEvents.filter(e => e.EventID === eventData.EventID)
      if (removedEvent && removedEvent.length > 0) {
        removedEvent[0].isBetPlaced = false
        removedEvent[0].activeStake = null
      }
    },
    getSecondsToStart (callback) {
      api.getSecondsToStart().subscribe(data => {
        if (data.SecondsToStart <= 0) {
          setTimeout(() => {
            this.getSecondsToStart(callback)
          }, 1000)
          return
        }
        this.disabledBettingTime = data.DisabledBettingTime
        this.isBettingEnabled = data.IsBettingEnabled
        this.secondsToStart = data.SecondsToStart
        this.roundLength = data.RoundLength
        if (data.SecondsToStart <= data.DisabledBettingTime) {
          this.isBettingEnabled = false
        }
        if (callback) {
          callback()
        }
        eventBus.secondToStartVSoccer(data.SecondsToStart)
      }, eventBus.onApiError)
    },
    getConfigData: function () {
      api.getConfig().subscribe(data => {
        this.config = data !== '' ? data : {}
        this.getMatches()
      }, eventBus.onApiError)
    },
    getMatches (isFullVideo) {
      api.getBalance()
      api.getMatches(true).subscribe(eventData => {
        if (eventData === '') {
          return
        }
        let panelMap = {}
        if (this.panelEvents && this.panelEvents.length > 0) {
          this.panelEvents.forEach(event => {
            panelMap[event.EventID] = event
          })
        }

        this.currentGame = this.addAdditionDataToMatch(
          eventData.LastFinishedEvent,
          this.numberOfMatchesToShow - 1,
          false,
          this.isBettingEnabled,
          null
        )
        eventData.PanelEvents.sort((eventA, eventB) => { return eventB.EventID - eventA.EventID })
        let preparedDataForPanelEvents = eventData.PanelEvents.splice(0, this.numberOfMatchesToShow)
        preparedDataForPanelEvents.sort((eventA, eventB) => { return eventA.EventID - eventB.EventID })
        let dataForPanelEvents = []
        preparedDataForPanelEvents.forEach((e, i) => {
          if (panelMap[e.EventID]) {
            dataForPanelEvents.push(panelMap[e.EventID])
          } else {
            this.addAdditionDataToMatch(e, i, false, i === 0 ? this.isBettingEnabled : true, null)
            dataForPanelEvents.push(e)
          }
        })
        this.panelEvents = dataForPanelEvents
        dataForPanelEvents.forEach((e, i) => {
          Vue.set(e, 'match', i)
        })
        if (this.panelEvents && this.panelEvents.length > 0) {
          if (this.activeEvent) {
            let isActiveEventExist = this.panelEvents.filter(event => event.EventID === this.activeEvent.EventID)
            if (isActiveEventExist.length === 0) {
              this.activeEvent = this.panelEvents[0]
            }
          } else {
            this.activeEvent = this.panelEvents[0]
          }
          if (this.currentGame != null) {
            api.getPlayList(this.currentGame).subscribe(data => {
              if (this.roundLength <= 0) {
                this.waitingForRoundLength = true
                this.tempData = data
              } else {
                this.waitingForRoundLength = false
                this.tempData = []
                this.populateVideoPlaylistData(data, isFullVideo)
              }
            }, eventBus.onApiError)
          }
        }
      }, eventBus.onApiError)
    },
    populateVideoPlaylistData (data, fullVideo) {
      this.totalVideoLength = (data.TotalLength / 1000) || 0
      let passSec = this.roundLength - this.secondsToStart
      let videoPositionPercentage = ((passSec * 1000) / data.TotalLength) * 100
      eventBus.showJackpotValue(null)
      let videoPercentage = 70
      if (fullVideo) {
        videoPercentage = 100
      }
      if (videoPositionPercentage < videoPercentage) {
        store.setGameInProgress(true)
        this.showSlider = false
        this.videoList = [data.VideoUrl]
        this.metaDataVideoList = data.Meta
        this.videoResult = data
        this.videoSeek = passSec
        eventBus.onRefreshActiveBets()
      } else {
        store.setGameInProgress(false)
        this.showSlider = true
        this.videoSeek = 0
        this.videoList = []
        this.metaDataVideoList = []
      }
    },
    onEventGetResult () {
      // get play list every 1s until you get result from server for currect match
      if (this.activeEvent && this.videoListTemp.length === 0) {
        api.getPlayList(this.activeEvent).subscribe(data => {
          if (!data.VideoUrl) {
            this.showSlider = true
            return
          }
          this.videoListTemp = [data.VideoUrl]
          this.metaDataVideoListTemp = data.Meta
        }, eventBus.onApiError)
      }
    },
    onEventNewRound (eventData) {
      this.waitingForRoundLength = false
      this.onEventShowResultHeader(false)
      this.tempData = []
      this.getSecondsToStart(() => {
        this.currentGame = null
        this.videoResult = {}
        this.getMatches()
        api.getBalance()
        eventBus.showJackpotValue(null)
        this.videoList = this.videoListTemp
        this.metaDataVideoList = this.metaDataVideoListTemp
        this.videoListTemp = []
        this.metaDataVideoListTemp = []
        this.showSlider = false
      })
    },
    onEventShowMatchResult (data) {
      this.showMatchResult = data
      this.showSlider = !data
    },
    onEventToggleAsideMenuMobile (isOpen) {
      this.showSideMenuMobile = isOpen
    },
    onEventToggleLeftMenu (isOpen) {
      this.showLeftMenu = isOpen
    },
    onEventShowConnectionErrorModal (isOpen) {
      this.showConnectionErrorModal = isOpen
    },
    onEventShowNewScore (eventData) {
      this.headerResult = eventData
    },
    onEventShowResultHeader (isOpen) {
      this.headerResult = {
        HomeScore: 0,
        AwayScore: 0
      }
      this.headerResultShow = isOpen
    },
    onEventShowBettingHistory (isOpen) {
      this.showBettingHistory = isOpen
    },
    onEventTimerTick (secondsToStart) {
      eventBus.onShowTime(secondsToStart)
      this.secondsToStart = secondsToStart
      if (secondsToStart <= this.disabledBettingTime) {
        this.isBettingEnabled = false
      }
      if (secondsToStart <= 5) {
        eventBus.onGetResult()
      }
      if (secondsToStart <= 0) {
        eventBus.onNewRound()
      }
    },
    selectedActiveStake: function (stake) {
      this.openConfirmModal = stake != null
    },
    closeConfirmModal: function () {
      this.openConfirmModal = false
    },
    setSwipe (data) {
      eventBus.$emit(EventConstants.VSOCCER_SWIPE_ACTION, data)
    },
    onEventShowJackpot (data) {
      let prepareData = this.getPreparedDataJackpot(data)
      this.fallenJackpots = prepareData.fallenJackpots
      this.showFallenJackpots = prepareData.showFallenJackpots
    },
    setFSVariable (data) {
      this.fullScreenActive = data
    }
  },
  created: function () {
    this.getSecondsToStart()
    this.getConfigData()
    eventBus.$on(EventConstants.VSOCCER_CONFIRM_MODAL_CLOSE, this.closeConfirmModal)
    eventBus.$on(EventConstants.VSOCCER_SELECTED_STAKE, this.selectedActiveStake)
    eventBus.$on(EventConstants.VSOCCER_REMOVE_PICKED_MATCH, this.onEventRemovePickedMatch)
    eventBus.$on(EventConstants.VSOCCER_TOGGLE_ASIDE_MENU_MOBILE, this.onEventToggleAsideMenuMobile)
    eventBus.$on(EventConstants.VSOCCER_TOGGLE_LEFT_MENU, this.onEventToggleLeftMenu)
    eventBus.$on(EventConstants.VSOCCER_GET_RESULT, this.onEventGetResult)
    eventBus.$on(EventConstants.VSOCCER_SHOW_MATCH_RESULT, this.onEventShowMatchResult)
    eventBus.$on(EventConstants.VSOCCER_SHOW_PROMO_SLIDER, this.onShowPromoSlider)
    eventBus.$on(EventConstants.VSOCCER_NEW_ROUND, this.onEventNewRound)
    eventBus.$on(EventConstants.VSOCCER_SHOW_MAINTENANCE, this.onEventShowConnectionErrorModal)
    eventBus.$on(EventConstants.VSOCCER_SHOW_API_ERROR, this.onEventShowConnectionErrorModal)
    eventBus.$on(EventConstants.VSOCCER_SHOW_NEW_SCORE, this.onEventShowNewScore)
    eventBus.$on(EventConstants.VSOCCER_SHOW_RESULTS_HEADER, this.onEventShowResultHeader)
    eventBus.$on(EventConstants.VSOCCER_SHOW_BETTING_HISTORY, this.onEventShowBettingHistory)
    eventBus.$on(EventConstants.VSOCCER_TIMER_TICK, this.onEventTimerTick)
    eventBus.$on(EventConstants.VSOCCER_SHOW_JACKPOT_VALUE, this.onEventShowJackpot)
    eventBus.$on(EventConstants.CHANGE_FULLSCREEN_VARIABLE, this.setFSVariable)
    eventBus.$on(EventConstants.CHECK_IF_MODAL, this.modalOnMobileLandscape)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (this.isMobile) {
      window.addEventListener('orientationchange', this.modalOnMobileLandscape)
      this.mobileDevice = true
    }
    setTimeout(function () { eventBus.onVDogFloatingAction(false) }, 500)
    eventBus.onGameScrollUnock('true')
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_CONFIRM_MODAL_CLOSE, this.closeConfirmModal)
    eventBus.$off(EventConstants.VSOCCER_SELECTED_STAKE, this.selectedActiveStake)
    eventBus.$off(EventConstants.VSOCCER_REMOVE_PICKED_MATCH, this.onEventRemovePickedMatch)
    eventBus.$off(EventConstants.VSOCCER_TOGGLE_ASIDE_MENU_MOBILE, this.onEventToggleAsideMenuMobile)
    eventBus.$off(EventConstants.VSOCCER_TOGGLE_LEFT_MENU, this.onEventToggleLeftMenu)
    eventBus.$off(EventConstants.VSOCCER_GET_RESULT, this.onEventGetResult)
    eventBus.$off(EventConstants.VSOCCER_SHOW_MATCH_RESULT, this.onEventShowMatchResult)
    eventBus.$off(EventConstants.VSOCCER_SHOW_PROMO_SLIDER, this.onShowPromoSlider)
    eventBus.$off(EventConstants.VSOCCER_NEW_ROUND, this.onEventNewRound)
    eventBus.$off(EventConstants.VSOCCER_SHOW_MAINTENANCE, this.onEventShowConnectionErrorModal)
    eventBus.$off(EventConstants.VSOCCER_SHOW_API_ERROR, this.onEventShowConnectionErrorModal)
    eventBus.$off(EventConstants.VSOCCER_SHOW_NEW_SCORE, this.onEventShowNewScore)
    eventBus.$off(EventConstants.VSOCCER_SHOW_RESULTS_HEADER, this.onEventShowResultHeader)
    eventBus.$off(EventConstants.VSOCCER_SHOW_BETTING_HISTORY, this.onEventShowBettingHistory)
    eventBus.$off(EventConstants.VSOCCER_TIMER_TICK, this.onEventTimerTick)
    eventBus.$off(EventConstants.VSOCCER_SHOW_JACKPOT_VALUE, this.onEventShowJackpot)
    eventBus.$off(EventConstants.CHANGE_FULLSCREEN_VARIABLE, this.setFSVariable)
    eventBus.$off(EventConstants.CHECK_IF_MODAL, this.modalOnMobileLandscape)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.modalOnMobileLandscape)
  },
  computed: {
    isSliderEnabled: function () {
      return (this.showMatchResult && this.videoResult) || (this.showSlider && !this.showMatchResult) || this.showFallenJackpots
    },
    nextRoundNumber: function () {
      if (this.panelEvents && this.panelEvents[0] && this.panelEvents[0].EventID) {
        return this.panelEvents[0].EventID % 1000
      }
      return 0
    },
    isEventExists: function () {
      return this.activeEvent != null
    },
    isCurrentGameExists: function () {
      return this.currentGame != null
    },
    isMobile: function () {
      return this.isMobileDevice()
    },
    numberOfMatchesToShow: function () {
      return this.config ? this.config.NumberOfMatchesToShow || 3 : 3
    },
    isFullScreenActiveComputed: function () {
      return this.fullScreenActive
    },
    isConfirmModalOpen: function () {
      return this.openConfirmModal && this.isEventExists && this.activeEvent.activeStake && !this.activeEvent.isBetPlaced
    },
    showJackpotHeader: function () {
      if (!this.showSlider && !this.showMatchResult) return true
      else return false
    },
    isPlayerEnabled: function () {
      return this.videoList.length > 0
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      eventBus.onVsoccerComponentLoaded()
    })
  },
  watch: {
    roundLength: function (roundLength) {
      if (roundLength > 0 && this.waitingForRoundLength) {
        this.populateVideoPlaylistData(this.tempData)
        this.waitingForRoundLength = false
        this.tempData = []
      }
    },
    isBettingEnabled: function (isBettingEnabledValue) {
      if (this.panelEvents && this.panelEvents.length > 0) {
        this.panelEvents.forEach((event, index) => {
          event.isBettingEnabled = index === 0 ? isBettingEnabledValue : true
        })
        if (!this.panelEvents[0].isBettingEnabled) {
          eventBus.disabledBettingMatch(this.panelEvents[0])
          if (this.panelEvents[0] === this.activeEvent) {
            this.activeEvent.isBettingEnabled = false
          }
        }
      }
    },
    isShowing: function (newVal, oldVal) {
      if (newVal) this.handleResize()
    }
  },
  props: {
    isDemoMode: {
      type: Boolean,
      default: false
    },
    isShowing: Boolean,
    componentsVisible: Boolean,

    amount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  }
}
</script>
